// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteAccountUpsearchRequestModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteAccountUpsearchRequestModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteAccountUpsearchRequestModel.discriminator = undefined;
EnterpriseCoordinatorSiteAccountUpsearchRequestModel.additionalProperties = false;
EnterpriseCoordinatorSiteAccountUpsearchRequestModel.attributeTypeMap = [
    {
        "name": "partyData",
        "baseName": "partyData",
        "type": "UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel"
    },
    {
        "name": "accountData",
        "baseName": "accountData",
        "type": "UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel"
    },
    {
        "name": "diagnosisSessionData",
        "baseName": "diagnosisSessionData",
        "type": "EnterpriseCoordinatorDiagnosisServiceModelsDiagnosisSessionModel"
    },
    {
        "name": "payorData",
        "baseName": "payorData",
        "type": "Array<UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel>"
    },
    {
        "name": "pharmacyData",
        "baseName": "pharmacyData",
        "type": "Array<UpsearchModelEnterpriseCoordinatorPharmacyServiceModelsPharmacyUpsearchModel>"
    },
    {
        "name": "prescriberData",
        "baseName": "prescriberData",
        "type": "Array<UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel>"
    },
    {
        "name": "prescriptionData",
        "baseName": "prescriptionData",
        "type": "Array<EnterpriseCoordinatorPrescriptionServiceModelsPrescriptionModel>"
    },
    {
        "name": "siteData",
        "baseName": "siteData",
        "type": "Array<UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel>"
    },
    {
        "name": "surveySessionData",
        "baseName": "surveySessionData",
        "type": "Array<number>"
    },
];
//# sourceMappingURL=enterpriseCoordinatorSiteAccountUpsearchRequestModel.js.map